/**
 * Creates a compnent from an Element
 *
 * @param tag
 * @param constructFn
 * @param defaultProps
 * @returns {function()}
 */
export default function construct(tag, constructFn, defaultProps = {}) {
    return (props) => {
        const c = kompo(document.createElement(tag));
        c.kompo.props = Object.assign({}, defaultProps, props || {});
        c.construct = constructFn;
        return c;
    };
}
export function kompo(Element) {
    const ke = Element;
    ke.kompo = {
        initial: true,
        props: {},
        defaultProps: {},
        mounts: [],
        statefulls: [],
        slots: {},
        routed: undefined,
        selector: undefined,
        unmount: undefined,
        debug: false,
        level: 0
    };
    return ke;
}
export function getProps(Element) {
    return Element.kompo.props;
}
//# sourceMappingURL=construct.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/construct.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11